import logo from "@/assets/logo-cineblocks-1.svg";
import studio3 from "@/assets/forgot-password/studio-3.png";
import { Link } from "wouter";
import { SplitScreen } from "@/components/ui/split-screen";
import { useState } from "react";
import { ForgotPasswordDialog } from "../components/forgot-password-dialog";
import { ForgotPasswordForm } from "../components/form";

export function ForgotPassword() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <SplitScreen
        firstComponent={
          <div className="h-full flex flex-col items-center justify-center">
            <img
              src={studio3}
              alt="Estúdio 3"
              className="rounded-2xl h-full 2xl:h-3/4 w-10/12 object-cover"
            />
          </div>
        }
        secondComponent={
          <div className="h-full flex flex-col items-center lg:items-start justify-center">
            <div className="max-w-md w-full space-y-2">
              <div className="text-center">
                <div className="flex items-center justify-center gap-2">
                  <img src={logo} alt="Logo Cineblocks" className="w-8" />
                  <h1 className="text-3xl font-bold">cineblocks</h1>
                </div>
                <p className="text-lg mt-2">Esqueceu sua senha?</p>
                <p className="text-sm text-label mt-1">
                  Digite o endereço de e-mail que você usou quando se inscreveu e lhe enviaremos instruções para redefinir sua senha.
                </p>
              </div>

              <ForgotPasswordForm
                successCallback={() => setOpen(true)}
              />

              <div className="text-left text-sm">
                Voltar para o &nbsp;
                <Link href="/login" className="text-primary hover:underline">
                  Login
                </Link>
              </div>
            </div>
          </div>
        }
      />

      <ForgotPasswordDialog open={open} setOpen={setOpen} />
    </>
  );
}